import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import { Button, Form, Modal } from 'react-bootstrap';
import ToggleSwitch from 'react-switch';

import { grape } from 'lib/css/colors';

function AllProductsReceivedModal({ show, onHide, manufacturer, onSave }) {
  const [allProductsReceived, setAllProductsReceived] = useState(false);
  useEffect(() => {
    if (manufacturer && show) {
      setAllProductsReceived(manufacturer.all_products_received || false);
    }
  }, [manufacturer, show]);

  const handleSave = () => {
    onSave(manufacturer.id, { all_products_received: allProductsReceived });
    onHide();
  };

  if (!manufacturer) return null;

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Update Products Status - {manufacturer.name}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="mb-4">
          <p className="text-muted">
            Toggle this setting to indicate whether all products have been received from this
            manufacturer.
          </p>
        </div>
        <Form>
          <Form.Group className="d-flex align-items-center justify-content-between">
            <Form.Label className="mb-0 font-weight-medium">All Products Received</Form.Label>
            <ToggleSwitch
              onColor={grape}
              checked={allProductsReceived}
              checkedIcon={false}
              uncheckedIcon={false}
              onChange={() => setAllProductsReceived(!allProductsReceived)}
              height={24}
              width={48}
            />
          </Form.Group>
          <div className="mt-3">
            <small className="text-muted">
              {allProductsReceived
                ? '✓ Marked as all products received'
                : '○ Not all products received yet'}
            </small>
          </div>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Cancel
        </Button>
        <Button variant="primary" onClick={handleSave}>
          Save
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

AllProductsReceivedModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  manufacturer: PropTypes.object,
  onSave: PropTypes.func.isRequired,
};

export default AllProductsReceivedModal;
